var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnDashboardGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.41559 19.9601C8.7785 19.3639 9.426 19 10.124 19H49.876C50.574 19 51.2215 19.3639 51.5844 19.9601L57.7084 30.0209C57.8991 30.3343 58 30.694 58 31.0608V40C58 41.1046 57.1046 42 56 42H4C2.89543 42 2 41.1046 2 40V31.0608C2 30.694 2.10088 30.3343 2.2916 30.0209L8.41559 19.9601Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4444 30H3.55556C2.69645 30 2 30.5373 2 31.2V40.8C2 41.4627 2.69645 42 3.55556 42H56.4444C57.3035 42 58 41.4627 58 40.8V31.2C58 30.5373 57.3035 30 56.4444 30Z",
    fill: "url(#paint0_linear_974_10218)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9545 34.9517H30V37.9062H32.9545V34.9517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8637 34.9517H35.9092V37.9062H38.8637V34.9517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7729 34.9517H41.8184V37.9062H44.7729V34.9517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6821 34.9517H47.7275V37.9062H50.6821V34.9517Z",
    fill: "#585858",
    stroke: "#979797",
    strokeWidth: 0.738636
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 32H6.25C5.55964 32 5 32.6716 5 33.5C5 34.3284 5.55964 35 6.25 35H8.75C9.44036 35 10 34.3284 10 33.5C10 32.6716 9.44036 32 8.75 32Z",
    fill: "#55DEFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_10218",
    x1: 30,
    y1: 30,
    x2: 30,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDashboardGateway);
export default __webpack_public_path__ + "static/media/icn_dashboard_gateway.7d6a9bafa50f30f070caafad7019643e.svg";
export { ForwardRef as ReactComponent };